var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDisabledTag = function SvgDisabledTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 38 38"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#disabled-tag_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#808A93",
    d: "M20.835 9.008c-.218-.027-.44 0-.646.078l-.001-.001c-.185.07-.353.18-.49.322L7.57 21.537a1.965 1.965 0 0 0 0 2.777l6.114 6.114a1.965 1.965 0 0 0 2.777 0l12.128-12.13a1.35 1.35 0 0 0 .4-1.136l-.923-5.988a1.37 1.37 0 0 0-1.243-1.242zm2.99 7.39a1.572 1.572 0 1 0-2.223-2.222 1.572 1.572 0 0 0 2.223 2.222Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M10.162 7.285a14.673 14.673 0 0 1 20.553 20.553zm-2.877 2.877a14.673 14.673 0 0 0 20.553 20.553zM32.232 32.28a18.745 18.745 0 1 1 .044-.044l-.02.02z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "disabled-tag_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h38v38H0z"
  })))));
};
export default SvgDisabledTag;